/** @jsxImportSource @emotion/react */

import { ButtonStyled, ModalActionsStyled, ModalStyled, useWindowWidth } from '@nike/nike-design-system-components';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import InvitationForm from './InvitationForm';
import UserManagementErrorSnackbar from '../UserManagementErrorSnackbar';
import UserManagementLoadingAnimation from '../UserManagementLoadingAnimation';

import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { invitationsActions } from './actions';
import { invitationsSelectors } from './reducer';
import { requestsActions } from '../../requests/actions';
import { requestsSelectors } from '../../requests/reducer';

const InvitationUpdateModal = () => {
  const dispatch = useDispatch();

  const invitationError = useSelector(requestsSelectors.invitationError);
  const invitationSuccess = useSelector(requestsSelectors.invitationSuccess);
  const selectedInvitationId = useSelector(invitationsSelectors.selectedInvitationId);

  const isMobile = useWindowWidth() < 769;

  useEffect(() => {
    if (invitationSuccess) {
      dispatch({ type: invitationsActions.deselectInvitation.name });
    }
  }, [invitationSuccess]);

  return (
    <ModalStyled
      appearance={isMobile ? 'fullscreen' : 'base'}
      closeModal={() => {
        dispatch({ type: invitationsActions.deselectInvitation.name });

        if (invitationError) {
          dispatch({ type: requestsActions.clearInvitationError.name });
        }
      }}
      css={{
        '@media (min-width: 769px)': {
          borderRadius: '5px',
          maxWidth: '1010px'
        }
      }}
      isOpen={selectedInvitationId}
      slots={{
        FooterSlot: (
          <ModalActionsStyled>
            <ButtonStyled disabled={invitationError} form='userInvitation' type='submit'>
              <TranslatedCopy id='userManagement.button.invited' />
            </ButtonStyled>
          </ModalActionsStyled>
        )
      }}
      title={new TranslatedCopy({
        id: 'userManagement.button.invited'
      }).toString()}
      modalHeaderCompProps={{ style: { paddingBottom: '10px' } }}
      modalContentCompProps={{ style: { overflowY: 'scroll' } }}
    >
      <InvitationForm />
      <UserManagementErrorSnackbar />
      <UserManagementLoadingAnimation />
    </ModalStyled>
  );
};

export default InvitationUpdateModal;
